import React, { useContext, memo, useEffect } from 'react'

import style from './Banner.module.scss'
import Link from '~components/Link'
import Img from 'gatsby-image'
import { withSession } from '~contexts/SessionContext'

import MicrocopyContext from '~contexts/MicrocopyContext'
import { graphql, StaticQuery } from 'gatsby'

const Banner = withSession(({
  children,
  session
}) => {
  const microcopy = useContext(MicrocopyContext)

  useEffect(() => {
    let elements = document.querySelectorAll('#banner h1')
    let index = 0

    const interval = setInterval(() => {
      elements[index].setAttribute('data-active', false)
      index = ++index % elements.length
      elements[index].setAttribute('data-active', true)
    }, 6000)

    return () => clearInterval(interval)
  }, [])

  return (
    <StaticQuery query={query} render={data => (
      <section className={style.banner} id='banner'>
        <div>
          <section className={style.text}>
            { children }
            <div className={style.buttons}>
              <Link 
                to='/get-started/' 
                microcopy={ microcopy }
                className={style.button}
                data-type='get-started'
              >
                { microcopy.text('guides.titles.learn_more', 'Learn more') }
              </Link>
              { !session.hasAccount ? (
                <Link 
                  to={ microcopy.text('headers.primary.buttons.signup.url') } 
                  microcopy={ microcopy }
                  className={style.button}
                  data-type='signup'
                >
                  { microcopy.text('headers.primary.buttons.signup.text') }
                </Link>
              ) : (
                <Link 
                  to={ microcopy.text('headers.primary.buttons.dashboard.url', 'https://account.box.com/developers/console') } 
                  microcopy={ microcopy }
                  className={style.button}
                  data-type='signup'
                >
                  { microcopy.text('headers.primary.buttons.dashboard.text', 'Go to Dev Console') }
                </Link>
              )}
            </div>
          </section>
          <section className={style.image}>
            <div><Img fluid={{...data.file.childImageSharp.fluid, objectFit: 'contain' }} /></div>
          </section>
        </div>
      </section>
    )} />
  )
})

const query = graphql`
query {
  file(relativePath: { eq: "platform.png" }, sourceInstanceName: { eq: "pages" }) {
    childImageSharp {
      # Specify the image processing specifications right in the query.
      # Makes it trivial to update as your page's design changes.
      fluid {
        ...GatsbyImageSharpFluid_withWebp_tracedSVG
      }
    }
  }
}
`

export default memo(Banner)
export { default as Title } from './Title'
